/*=========================================================================================
  File Name: moduleTransactionMngMutations.js
  Description: Transaction Module Mutations
  ----------------------------------------------------------------------------------------
  Author: Faruk Nikmorad
  Auth Date: 30062020
==========================================================================================*/


export default {
  SET_TRANSACTION_LIST (state, transactions) {
    state.transactions = transactions
  },
}
